<template>
  <div class="mon-target-event-detail">
    <div class="dashboard-info-item setting-button">
      <lego-button border primary medium @click="goEventSetting" :disabled="isDisableButton"
        >{{ t('menu.eventPolicyDetails') }}
      </lego-button>
    </div>
    <c-scroll style="padding: 16px 24px 0 0; max-height: 618px; overflow-x: hidden">
      <!-- 발행 조건 -->
      <div class="dashboard-info-item">
        <v-runtime-template :template="metricKeyPolicy" />
      </div>
      <div class="dashboard-info-item condition">
        <span class="title-noti">{{ t('page.eventStatus.condition') }}</span>
        <span>{{ conditionText }}</span>
      </div>
      <!-- 성능 항목 -->
      <div style="height: 240px; margin-bottom: 24px">
        <SummaryMetricChart
          v-if="initChart"
          enableLegend
          :fetchStatus="fetchStatus"
          :metric="metricSummary"
          :date-option="searchDate"
          :search-model="searchModel"
          :selectedTargets="selectedTargets"
          :collInterval="interval"
          :parent-class="parentClass"
          :isNow="searchDate.isNow"
          :showLastValue="false"
          @onFetched="onFetched"
        />
      </div>
      <!-- 알림 이력 -->
      <div class="dashboard-info-item notification">
        <div class="title-noti">{{ t('page.eventStatus.notice') }}</div>
        <lego-paging-table
          ref="tableNotification"
          v-model="selectedNoti"
          isNotScrollX
          fixedColumn
          :items="eventNotifyData"
          :headers="headers"
          :noClickRow="true"
          :noControl="true"
          @sort="onClickSort"
        >
        </lego-paging-table>
      </div>
    </c-scroll>
  </div>
</template>

<script>
import _ from 'lodash';

import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from './monTarget.mixin.js';
import eventModalMixin from '@/mixins/eventModal.mixin.js';
import { NOTIFY_METHOD } from '@/containers/utils/constant';
import moment from 'moment';
import SummaryMetricChart from '../components/metric/SummaryMetricChart.vue';
import widgetAddConfigMixin from '../widget/configs/widgetAddConfigMixin';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import VRuntimeTemplate from 'vue3-runtime-template';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';
import { SUB_OBJECT_TYPES_WITH_K8S } from '@/containers/utils/constant';

const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();
export default {
  emits: ['close', 'open-event-add-setting', 'open-event-detail'],
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    searchDate: {
      type: Object,
      default: () => ({})
    },
    parentClass: {
      type: String,
      default: ''
    }
  },
  components: {
    VRuntimeTemplate,
    SummaryMetricChart
  },
  mixins: [i18nMixin, monTargetMixin, eventModalMixin, widgetAddConfigMixin],
  inject: ['sharedInterval'],
  data() {
    return {
      initChart: false,
      summaryData: [],
      isEventAddShow: false,
      isShowAddWidget: false,
      metricSummary: {},
      metricKeyPolicy: '',
      metricUnit: '',
      metricFunction: '',
      showLocalDashBoard: false,
      eventNotifyData: [],
      productId: '',
      eventId: '',
      productResourceId: '',
      productTypeCode: '',
      productName: '',
      startDate: '',
      eventStartDt: '',
      eventEndDt: '',
      selectedNoti: [],
      headers: [
        {
          text: this.$t('page.eventStatus.name'),
          value: 'userName',
          width: 142,
          defaultValue: this.$t('label.deletedUser'),
          sortable: true,
          customCell: {
            props: {
              value: {
                type: [String],
                default: ''
              }
            },
            computed: {
              content() {
                return this.value ? this.value : this.$t('label.deletedUser');
              }
            },
            template: `
              <div class="ellipsis" style="display:inline-block; max-width: 100%;" v-lego-tooltip:ellipsis="content">
              {{ content }}
              </div>`
          }
        },
        {
          text: this.$t('page.eventStatus.email'),
          value: 'userEmail',
          width: 142,
          defaultValue: '-',
          sortable: false
        },
        {
          text: this.$t('page.eventTab.NotifyMethod'),
          width: 110,
          minWidth: 110,
          defaultValue: '-',
          customCell: this.getMethodNotification
        },
        {
          text: this.$t('page.eventStatus.notificationTime'),
          value: 'sendDt',
          width: 175,
          minWidth: 175,
          isNotResize: true,
          defaultValue: '-',
          sortable: true,
          customCell: (value) => (value ? formatDateTime(value, FULL_TIME_FORMAT) : '')
        }
      ],
      dateOption: {
        startDate: '',
        endDate: '',
        formatter: '{HH}:{mm}'
      },
      isDisableButton: true,
      conditionText: '',
      searchModel: {
        productTypeCode: '',
        subTypeCode: '',
        productTypeItem: {},
        subTypeItem: {}
      },
      fetchStatus: false,
      selectedTargets: []
    };
  },
  watch: {
    params: {
      immediate: true,
      handler(self, prev) {
        this.isDisableButton = !self?.policyId;
        const diff = self?.eventId !== prev?.eventId;
        if (diff) {
          this.prepareData();
          this.init();
        }
      }
    },
    searchDate: {
      deep: true,
      immediate: false,
      handler(value, oldValue) {
        this.onSearchDataChange(value, oldValue);
      }
    }
  },
  created() {
    this.prepareData();
  },
  provide() {
    return {
      clickAction: () => {},
      isEvent: true
    };
  },
  methods: {
    onFetched() {
      this.fetchStatus = false;
    },
    prepareData() {
      this.productId = this.params.productId;
      this.eventId = this.params.eventId;
      this.productResourceId = this.params.productResourceId;
      this.productTypeCode = this.params.productTypeCode;
      this.productName = this.params.productName;
      this.startDate = this.params.startDate;
      this.policyId = this.params.policyId;
      this.searchModel = {
        ...this.searchModel,
        productTypeCode: this.params.productTypeCode,
        objectTypeCode: this.params.objectTypeCode
      };
      this.selectedTargets = [
        {
          ...this.params,
          productSq: this.params.productId,
          resourceId: this.params.productResourceId
        }
      ];
    },
    init() {
      this.getEventDuringTime();
      this.getEventNotify();
      this.getEventPolicyDtl(this.policyId, true);
    },
    getMethodNotification(value, idx, item) {
      const resultMail = item.resultMail || '';
      const resultSMS = item.resultSMS || '';
      const resultMessenger = item.resultMessenger || '';

      let htmlNoti = '<div class="icon-method">';

      //get icon method mail, sms, messenger
      const mailMethod = resultMail.replace(' ', '_').toLowerCase();
      const smsMethod = resultSMS.replace(' ', '_').toLowerCase();
      const messengerMethod = resultMessenger.replace(' ', '_').toLowerCase();

      htmlNoti += this.getIcon(
        'noti_mail_' + mailMethod,
        resultMail,
        mailMethod == 'success' ? true : false
      );
      htmlNoti += this.getIcon(
        'noti_sms_' + smsMethod,
        resultSMS,
        smsMethod == 'success' ? true : false
      );
      htmlNoti += this.getIcon(
        'noti_messenger_' + messengerMethod,
        resultMessenger,
        messengerMethod == 'success' ? true : false
      );
      htmlNoti += '</div>';

      htmlNoti = htmlNoti.replace(/\n/g, '');

      return htmlNoti;
    },
    getIcon(name, method, isActive = false) {
      const nameTooltip = name.split('_')[1]
        ? 'button.' + name.split('_')[1].toString().toUpperCase()
        : '';

      if (!nameTooltip) return '';

      const methodTooltip = 'label.' + method.replace(' ', '_').toLowerCase();
      const escapeNameTooltip = this.$util.escapeHTML(nameTooltip);
      const escapeMethodTooltip = this.$util.escapeHTML(methodTooltip);
      const fullNameTooltip = `${this.$t(escapeNameTooltip)} ${this.$t(escapeMethodTooltip)}`;

      return (
        `<span style="display: flex">
          <lego-icon
            iconType="df"
            icon="` +
        name +
        `"
            :size="16"
            class="` +
        (isActive ? 'alert-available' : 'alert-unavailable') +
        `"
        v-lego-tooltip="'${fullNameTooltip}'"
          />
        </span>`
      );
    },
    onClickSort(header) {
      legoEventBus.$emit('click-outside-datePicker');
      this.eventNotifyData = this.$util.customSort(
        this.eventNotifyData,
        header.value,
        header.asc ? 'asc' : 'desc'
      );
    },
    getEventDuringTime() {
      let curDt = moment(new Date());
      let eventDt = moment(new Date(this.startDate));
      let oneAfter = moment(new Date(eventDt)).add(1, 'hour'); // 이벤트 발생 1시간 후

      // 이벤트 발생시간: 5시간전 ~ 이벤트 ~ 1시간후
      if (curDt > oneAfter) {
        let fiveBefore = moment(new Date(eventDt)).add(-5, 'hour'); // 5시간전
        this.eventStartDt = fiveBefore.toISOString();
        this.eventEndDt = oneAfter.toISOString();

        // 성능수집 데이터 14일만 조회, 이벤트 발생 후 최근 데이터만 가져와도 무방
        if (moment(curDt).diff(moment(eventDt), 'days') > 14) {
          this.eventStartDt = moment(curDt).add(-6, 'hour').toISOString();
          this.eventEndDt = curDt.toISOString();
        }
      } else {
        // 현재시각 ~ 6시간 전
        this.eventStartDt = moment(new Date()).add(-6, 'hours').toISOString();
        this.eventEndDt = moment(new Date()).add(4, 'minute').toISOString();
      }
    },
    // 이벤트 설정 페이지로 이동
    goEventSetting() {
      // Function for check authorization resource
      const params = {
        productResourceIds: [this.productResourceId],
        actionName: 'MonitorView',
        productTypeCode: this.productTypeCode
      };

      this.$store
        .dispatch('authStore/checkProductResource', params)
        .then((data) => {
          if (data.type === this.$const.AuthorizationResult.ALLOW) {
            this.$emit(
              'open-event-detail',
              this.policyId,
              this.productTypeCode,
              this.params.projectId
            );
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
    updateSearchModel(subTypeCode) {
      this.searchModel = {
        ...this.searchModel,
        subTypeCode: subTypeCode ?? ''
      };
    },
    mapSelectedTargets(objectName, objectType, objectDisplayName) {
      return this.selectedTargets.map((target) => ({
        ...target,
        objectName: objectName ?? '',
        objectType: objectType ?? '',
        objectDisplayName: objectDisplayName ?? ''
      }));
    },

    getEventPolicyDtl(polId, init = false) {
      if (!polId) return;
      const listDataCheckAuth = [
        { productResourceId: polId, productName: this.params.productName }
      ];
      const params = {
        policyId: polId,
        productTypeCode: this.productTypeCode,
        listDataCheckAuth
      };
      this.initChart = !init;
      this.fetchStatus = false;
      this.$store
        .dispatch('authStore/checkEventPolicies', params)
        .then((res) => {
          if (res.type !== this.$const.AuthorizationResult.ALLOW) return;
          const data = res.responseData;
          if (!this.$util.isNotEmpty(data)) return;

          const prodName = _.get(data, 'productSummary.productSubName');
          const prodType = _.get(data, 'productSummary.productSubType');
          const prodTypeCode = _.get(data, 'productSummary.productTypeCode');
          this.metricSummary = { ...data.metricSummary, productTypeCode: this.productTypeCode };

          const isKubernetesSubType =
            prodTypeCode === 'Kubernetes' &&
            SUB_OBJECT_TYPES_WITH_K8S.includes(prodType) &&
            prodName &&
            prodType;

          if (isKubernetesSubType) {
            this.updateSearchModel(prodType);
            this.selectedTargets = this.mapSelectedTargets(prodName, prodType, prodName);
          } else {
            const objectType = _.get(data, 'objectType');
            const objectName = _.get(data, 'objectName');
            const objectDisplayName = _.get(data, 'objectDisplayName');
            this.updateSearchModel(objectType);
            this.selectedTargets = this.mapSelectedTargets(
              objectName,
              objectType,
              objectDisplayName
            );
          }
          this.metricFunction =
            data.eventThreshold.metricFunction === '' ? '-' : data.eventThreshold.metricFunction;

          // 발생조건 표기
          this.presentMetricKeyPolicy(data);
          this.initChart = true;
          this.fetchStatus = true;
        })
        .catch(() => this.$emit('close', true));

      this.policyId = polId;
    },
    // 이벤트 알림 api
    async getEventNotify() {
      if (!this.eventId) return;
      let params = { eventId: this.eventId };

      this.apiGetEventNotify(params, this.productTypeCode, true)
        .then((data) => {
          if (!data.contents.length) this.eventNotifyData = [];
          if (this.$util.isNotEmpty(data)) {
            if (data.totalCount > 0) {
              this.eventNotifyData = data.contents.map((notiStateItem) => {
                let eventNotiData = notiStateItem.notificationStates;
                let lstSendMethod = eventNotiData.map((item) => ({
                  sendMethod: item.sendMethod,
                  sendResult: item.sendResult
                }));

                let resultSend = (method) => {
                  let result = '';

                  for (let send of lstSendMethod) {
                    if (send.sendMethod == method) {
                      result = send.sendResult;
                      break;
                    }
                  }

                  return result;
                };

                return {
                  userName: notiStateItem.user ? notiStateItem.user.user_name : '',
                  userId: notiStateItem.user ? notiStateItem.user.id : '',
                  userEmail: notiStateItem.user ? notiStateItem.user.email : '',
                  sendDt: this.dateFormatter(eventNotiData[0].sendDt),
                  resultMail: resultSend(NOTIFY_METHOD.METHOD.MAIL),
                  resultMessenger: resultSend(NOTIFY_METHOD.METHOD.MESSENGER),
                  resultSMS: resultSend(NOTIFY_METHOD.METHOD.SMS)
                };
              });
            }
          }
        })
        .catch((err) => {
          if (err && err.code == 'AccessDenied') {
            this.$alert(err);
          }
          this.$emit('close', true);
        });
    },
    close() {
      this.$emit('close', true);
    },
    dateFormatter(inDate) {
      return moment(inDate).format('YYYY-MM-DD HH:mm:ss');
    },
    getSearchDate() {
      let queryStartDt,
        queryEndDt,
        chartTimeUnit,
        dateType = 1;

      if (this.searchDate) {
        queryStartDt = this.searchDate.queryStartDt;
        queryEndDt = this.searchDate.queryEndDt;
        chartTimeUnit = this.searchDate.chartTimeUnit;
        dateType = this.searchDate.dateType;
      } else {
        // default date
        queryStartDt = moment(new Date()).add(-6, 'hours').toISOString(); // 6시간 전
        queryEndDt = moment(new Date()).toISOString();
        chartTimeUnit = '5m';
      }

      // Global CDN
      if (dateType === 1 && this.isCdn) {
        queryStartDt = moment(queryStartDt).add(-1, 'days').toISOString();
        queryEndDt = moment(queryEndDt).add(-1, 'days').toISOString();
      }
      return {
        queryStartDt: queryStartDt,
        queryEndDt: queryEndDt,
        chartTimeUnit: chartTimeUnit
      };
    },
    onSearchDataChange(value, oldVaue) {
      if (value == oldVaue || value === undefined) {
        return;
      }
      this.getEventPolicyDtl(this.policyId);
    },
    // 발생조건 표기
    presentMetricKeyPolicy(data) {
      const ftCount = data.ftCount;
      const thresholdType = ['SINGLE_VALUE', 'RANGE_VALUE'];
      if (thresholdType.includes(data.eventThreshold.thresholdType)) {
        const dangerType = data.eventLevel.substring(0, 1);
        this.metricKeyPolicy = `<div class="ellipsis" v-lego-tooltip="'${this.$util.capitalize(
          data.eventLevel
        )}'">${this.$util.dangerIcon(dangerType, dangerType)}</div><div style="margin-left:4px">${
          data.displayEventRule
        }</div>`;
      }

      let statistics = data.eventPolicyStatistics.eventPolicyStatisticsType;
      statistics =
        statistics === '' || statistics === null
          ? this.$t('label.nonStatistics')
          : this.$t('label.statistics');
      // this.metricKeyPolicy +=
      //   ' ' + '(FT: ' + ftCount + ' / ' + this.metricFunction + ' / ' + statistics + ')';
      this.conditionText = 'FT: ' + ftCount + ' / ' + this.metricFunction + ' / ' + statistics;
    },

    handleCloseEventDetailModal() {
      this.closeEventDetailModal();

      this.$nextTick(() => {
        this.init();
      });
    }
  },
  computed: {
    interval() {
      return this.sharedInterval.interval;
    }
  }
};
</script>

<style lang="scss" scoped>
.mon-target-event-detail {
  padding: 0 0 0 24px;

  :deep .icon-method {
    display: flex;
    justify-content: space-around;

    span {
      width: 16px;
      height: 16px;
    }
  }

  :deep .chart-title-container_text,
  :deep .chart-title {
    max-width: 100% !important;
  }

  .title-chart {
    display: flex;
    justify-content: space-between;
  }

  .metric-name {
    align-self: center;
  }

  .title-noti {
    size: 15px;
    line-height: 16px;
    font-weight: 500;
  }

  .notification {
    flex-direction: column;
  }

  .last-value {
    gap: 2px;
    display: flex;
  }

  :deep {
    .multi-dropdown-wrap .lego-dropdown__items_box {
      left: -260px !important;
    }
  }

  .condition {
    display: flex;
    flex-direction: column;

    .title-noti {
      margin-bottom: 6px;
    }
  }

  .dropdown-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0;
    gap: 4px;

    .lego-drop-holder {
      display: flex !important;
    }

    .object-check {
      width: 180px !important;
    }
  }
  :deep {
    .summary-chart-item {
      .chart-title {
        max-width: 450px;
      }
    }
  }
}

.setting-button {
  padding: 0px 24px;
  justify-content: right !important;
  margin-bottom: 8px !important;
}

.dashboard-info-item {
  display: flex;
  justify-content: flex-start;
  margin: 0 0 24px;

  &:last-child {
    margin-bottom: 0px;
  }
}

.eventNoti {
  display: flex;

  .name {
    width: 150px;
  }

  .icon {
    width: 120px;

    span {
      display: inline-block;
      width: 32px;

      img {
        width: 90%;
        margin-top: -3px;
        vertical-align: top;
      }
    }
  }

  .time {
    width: 150px;
  }
}

.alert-available {
  cursor: default !important;
}

:deep .alert-unavailable {
  cursor: default !important;
  color: #b3b7c1 !important;
  opacity: 1;
}

.alert-available {
  color: #364fc7 !important;
}

:deep {
  .lego-table__no-data {
    min-height: 173px !important;
  }
  .chart-container {
    padding-bottom: 10px;
  }
}
</style>
